import React, { createContext, useState, useContext, useEffect } from 'react';

// 1. إنشاء الـ Context بقيمة افتراضية null
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
      const initAuth = () => {
        //console.log("🔍 [Debug] Checking LocalStorage for user...");
        try {
          const savedUser = localStorage.getItem('user');
          //console.log("🔍 [Debug] Raw user data from storage:", savedUser);
  
          if (savedUser && savedUser !== "undefined" && savedUser !== "null") {
            const parsedUser = JSON.parse(savedUser);
            //console.log("🔍 [Debug] Parsed User:", parsedUser);
            setUser(parsedUser);
          } else {
            console.log("🔍 [Debug] No user found in storage.");
          }
        } catch (error) {
          console.error("❌ [Debug] JSON Parse Error:", error);
        } finally {
          //console.log("🔍 [Debug] Setting loading to false.");
          setLoading(false); // دي لازم تتنفذ عشان الكلمة تختفي
        }
      };
      initAuth();
  }, []);

  const login = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('user');
    localStorage.removeItem('token');
  };

  // 🎯 دالة فحص الصلاحيات مع حماية ضد الـ Undefined
  const hasPermission = (module, action = 'read') => {
    // 1. لو مفيش يوزر أو رول، اقفل الحنفية فوراً
    if (!user || !user.role) return false;
  
    // 2. استثناء الـ Super Admin
    if (user.role.name === 'SUPER_ADMIN' || user.role.role_id === 1) {
      return true; 
    }
  
    try {
      // 3. فك الصلاحيات لو جيا نص
      const permissions = typeof user.role.permissions === 'string'
        ? JSON.parse(user.role.permissions)
        : user.role.permissions;
  
      // 🎯 اللعبة هنا: بنحول اسم الموديول لـ lowercase عشان نضمن التطابق
      const targetModule = module?.toLowerCase();
      
      // 🔍 سطر الديبج ده هو اللي هيعرفنا ليه بيفتح كله
      // افتح الـ Console وشوف القيمة اللي بتطلع هنا
      const isAllowed = permissions?.[targetModule]?.[action] === true;
      
      console.log(`🔐 [Check] Module: ${targetModule} | Action: ${action} | Result: ${isAllowed}`);
  
      return isAllowed;
    } catch (e) {
      console.error("❌ Permission Check Error:", e);
      return false;
    }
  };

  const value = {
    user,
    loading,
    login,
    logout,
    hasPermission
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, hasPermission }}>
      {/* لو لسه بيحمل بنوري سبنر، لو خلص بنرندر الأبناء */}
      {!loading ? children : (
        <div className="h-screen w-screen flex flex-col items-center justify-center bg-[#f3f4f6]">
          <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-900 mb-4"></div>
          <span className="text-blue-900 font-black italic animate-pulse uppercase tracking-widest text-[10px]">
            Initializing Security Matrix...
          </span>
        </div>
      )}
    </AuthContext.Provider>
  );
};

// 🎯 الـ Hook المطور مع صمام الأمان
export const useAuth = () => {
  const context = useContext(AuthContext);
  
  // لو الـ context لسه null (المكون مستدعى بره الـ Provider)
  if (context === undefined || context === null) {
    // نرجع قيم وهمية "Safe Fallback" عشان السيستم ما يضربش White Screen
    return {
      user: null,
      loading: true,
      login: () => {},
      logout: () => {},
      hasPermission: () => false
    };
  }
  
  return context;
};
